import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnAddProtocol = new ThunderDispatcher('__onAddProtocol');
//# sourceMappingURL=dispatchers.js.map